<template>
  <div class="warp_upload_file">
    <label class="file noshadow" >
      <span class="file-custom" data-line-before="browse_photo"></span>
      <input type="file"  aria-label="File browser example" v-on:change="button_upload_pics" >
    </label>
    <canvas id="preview" width="300" height="300" ></canvas>
  </div>
</template>

<script>
export default {
  data() {
    return {
      canvas:null,
      ctx:null,
      img:null,
      show_preview:false,
    }
  },
  methods: {
    button_upload_pics(e) {
      console.log('button_upload_pics');
      this.canvas = document.getElementById('preview');
      this.ctx = this.canvas.getContext("2d");
      this.img = new Image();
      var files = e.target.files; // FileList object
      var file = files[0];
      var that = this;
      if(file.type.match('image.*')) {
        var reader = new FileReader();
        // Read in the image file as a data URL.
        reader.readAsDataURL(file);
        reader.onload = function(evt){
          if( evt.target.readyState == FileReader.DONE) {
            that.img.onload = function() {
              that.ctx.canvas.width = that.img.width;
              that.ctx.canvas.height = that.img.height;
              that.ctx.drawImage(that.img, 0, 0, that.img.width, that.img.height);
            }
            that.img.src = evt.target.result;
            console.log('upload_pics done');
            that.show_preview = true;
            // setTimeout(function(){ that.a_pics_has_been_send = true; that.img_cleared = false; that.process_canvas_to_pico(img); }, 300);
          }
        }
      } else {
        alert("not an image");
      }
    },

  },
};
</script>
